export interface Product {
    ProductID: number;
    ProductName: string;
    Description: string;
}
